import { TemplateRef, ViewContainerRef } from "@angular/core";
import { UserHelperService } from "@main/users/user-helper.service";

export abstract class AccessDirectiveBase {
    constructor(
        protected templateRef: TemplateRef<any>,
        protected viewContainer: ViewContainerRef,
        protected userHelperService: UserHelperService
    ) {}

    protected abstract get lookupClaimType(): string;

    protected apply(inputValues: string | string[]) {
        const values = Array.isArray(inputValues) ? inputValues : [inputValues];

        if (this.userHelperService.hasAccess(this.lookupClaimType, values)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
